import Vue from 'vue';
import { router } from './router/index';
import VueAnalytics from 'vue-analytics';
import util from '@/lib/util';
import appconst from "./lib/appconst";
import { Watch } from 'vue-property-decorator';
// import elementUi from "element-ui";
// import localeEn from "element-ui/lib/locale/lang/en";
// //mport localeEs from "element-ui/lib/locale/lang/es";
// Vue.use(elementUi, { locale: localeEn });


// import "bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "font-awesome/scss/font-awesome.scss";

//sweet alert
import VueSwal from "vue-swal";
Vue.use(VueSwal);

// load constants from server.
util.loadScript(`${appconst.remoteServiceBaseUrl}/constants/GetScripts`);

// application services plugin.
import {AppServicesPlugin} from "@/asdcom/plugins/AppServices/AppServicesPlugin";
Vue.use(AppServicesPlugin);

import * as moment from "moment";

//// Vue localization ************
//import Vuei18n from 'vue-i18n';

// const i18n = new VueI18n({
//     locale: 'en', // set locale
//     messages, // set locale messages
//   })

// Vue.use(i18n);

//// https://auralinna.blog/post/2018/how-to-build-a-complete-form-with-vue-js 
// import translations from "./resources/translations";

// Vue.use(VueI18n);
// Vue.use(Vuelidate);

// Vue.config.formApiUrl = process.env.FORM_API_URL;

// const i18n = new VueI18n({
//   locale: 'en',
//   fallbackLocale: 'en',
//   messages: translations
// })
//// End Vue localization ***********


// google analytics plugin.
Vue.use(VueAnalytics, {
  id: asdcom.config.gAnalyticsId,
  router,
  debug: {
    //enabled: asdcom.config.logLevel == 1,
    // 	sendHitTask: isProd
    // sendHitTask: false
  },
  // autoTracking: {
  // 	exception: true,
  // },
  autoTracking: {
    pageviewTemplate(route: any) {
      return {
        page: route.path,
        title: route.name, // document.title, //
        location: window.location.href,
      };
    },
    exception: true,
  },
});


// Set Log level.
abp.log.level = asdcom.config.logLevel ? asdcom.config.logLevel : abp.log.levels.INFO;

// // VcpOnlineOk specific code.
// import "./assets/main.vcponlineok.css";



// Vue.prototype.$eventBus = new Vue();

const bus = new Vue();

class MainAsdcom extends Vue {
  currentPageName:string = "";
  activityTimer: number | undefined = undefined;
  lastActivityTime = new Date();
  activityTimeoutMillSec = appconst.defaultInactivityTimeoutMinutes * 60000;

  created() {
      
  }

  mounted() {
    bus.$on("startTimer", this.startInactivityTimer)
  }

  startInactivityTimer() {
    // abp.log.debug("startInactivityTimer called ...");
    console.log("startInactivityTimer called from main.asdcom*********************");
    // calc inactivity timeout milliseconds.
    let mnts: any = asdcom.config.activityTimeoutMin || appconst.defaultInactivityTimeoutMinutes;
    if(util.abp.auth.hasPermission("Pages.Tenant.StaffUser")){
      mnts = asdcom.config.activityTimeoutMinAdvocate || appconst.defaultInactivityTimeoutMinAdvocate;
    }
    this.activityTimeoutMillSec = mnts * 60000;
    // abp.log.debug({ "timer minutes": mnts, "timer millisec": this.activityTimeoutMillSec });


    this.resetTimer();

    // reset timer on DOM Events
    document.onload = this.setLastActivityTime;
    //document.onmousemove = this.setActivityTime;
    document.onmousedown = this.setLastActivityTime; // touchscreen presses
    document.ontouchstart = this.setLastActivityTime;
    document.onclick = this.setLastActivityTime; // touchpad clicks
    document.onscroll = this.setLastActivityTime; // scrolling with arrow keys
    document.onkeypress = this.setLastActivityTime;
  }

  setLastActivityTime(e: any) {
    this.lastActivityTime = new Date();
    // abp.log.debug({"setLastActivityTime":this.lastActivityTime.getTime(), "event":e});
  }

  resetTimer() {
    // abp.log.debug("resetTimer called ...");
    clearTimeout(this.activityTimer);

    // calc activity.
    if (this.isUserActive()) {
      this.isSessionValid().then((res: boolean) => {
        if (res) {
          // this.timer = setTimeout(this.logoutUser, this.activityTimeoutMillSec) as any;
          this.activityTimer = setTimeout(this.resetTimer, 60000) as any;
        }
      });
    }
    else{
      this.logoutUser();
    }
  }

  logoutUser() {
    this.$appsvs.tokenAuth.logOut().then(() => {
      // abp.log.debug("main.logoutUser called...");

      if (util.abp.auth.hasPermission("Pages.Tenant.StaffUser")) {
        //sweetAlert({text:"You have been logged out due to inactivity.", icon:"info"});
        //this.$router.push('/');
        location.reload();
      } else {
        window.location.replace("https://www.google.com");
      }
    });
  }

  isUserActive():boolean{
    const lastActivityDiffMillSec = new Date().getTime() - this.lastActivityTime.getTime();
    abp.log.debug({"lastActivityDiffMillSec":lastActivityDiffMillSec, "timeOutMillSec":this.activityTimeoutMillSec});
    // abp.log.debug({"isUserActive":this.activityTimeoutMillSec > lastActivityDiffMillSec});
    return this.activityTimeoutMillSec > lastActivityDiffMillSec;
  }

  async isSessionValid(callCounter: number = 0): Promise<boolean> {
    // abp.log.debug("isSessionValid called..... counter = " + callCounter);
    const tokenExp = localStorage.getItem(appconst.authorization.tokenExpName);
    // abp.log.debug({ "tokenExp": tokenExp });
    if (tokenExp == null) {
      // abp.log.debug("isSessionValid return false");
      return false;
    } else {
      const timeBufferMillSec = 1000 *60
      const tokenTimeupMillSec = (new Date(tokenExp).getTime() - new Date().getTime()) - timeBufferMillSec;
      // console.warn( "this.activityTimeoutMillSec",this.activityTimeoutMillSec, "tokenTimeupMillSec", tokenTimeupMillSec);
      if (this.activityTimeoutMillSec < tokenTimeupMillSec) {
        // abp.log.debug("isSessionValid return true");
        return true;
      } else {
        //refresh token.
        // abp.log.debug("isSessionValid before refresh token");
        return this.$appsvs.tokenAuth.refreshAuthToken().then(res => {
          // abp.log.debug("refreshAuthToken returned.");
          if (callCounter < 3) {
            const cntr = callCounter + 1;
            return this.isSessionValid(cntr);
          }
          // abp.log.debug("isSessionValid return true2");
          return true;
        });
      }
    }
  }

  @Watch('$store.session.user')
  userInactivity(val: any, oldVal: any) {
    //abp.log.debug({ "session user watch:": [val, oldVal] });
    if (val != undefined) {
      this.startInactivityTimer(); //this.logoutUser);
    }
  }

}



